<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "OutputUser" });
import { OutputMobile, OutputWhatsapp, OutputEmail } from "../../index.js";
export let user;
export let subject = void 0;
export let heading = void 0;
$: name = user?.name === void 0 ? "" : `${user.name.first} ${user.name.last}`;
</script>

{#if user }

    <div class = 's8-user'>

        {#if user.image?.url !== undefined }
            <div class = 's8-image'>
                <figure>
                    <img src = { user.image.url } alt = { name } />
                </figure>
            </div>
        {/if}

        <div class = 's8-personal'>

            {#if heading }
                <span class = 's8-tagline'> { heading } </span>
            {/if}

            <span class = 's8-name'>{ name }</span>

            {#if heading === undefined && user.position }
                <span class = 's8-position'>{ user.position }</span>
            {/if}

            {#if user.mobile}
                <div class = 's8-contact'>
                    <OutputMobile mobile = { user.mobile } />
                    <OutputWhatsapp mobile = { user.mobile } { subject } />
                    <OutputEmail email = { user.email } { subject }/>
                </div>
            {/if}
        </div>

    </div>

{/if}

<style>

    div.s8-user {

        display: flex;
        align-items: stretch;
        gap: 5px;
    }

        div.s8-user div.s8-image {
            width: 45px;
            height: 45px;
        }

        div.s8-user div.s8-image figure {
                aspect-ratio: 1 / 1;
                border-radius: 8px;
                overflow: hidden;
            }

        div.s8-user div.s8-image figure img {
                    -o-object-fit: cover;
                       object-fit: cover;
                    -o-object-position: center;
                       object-position: center;
                    width: 100%;
                    height: 100%;
                }

        div.s8-user div.s8-personal {
            display: flex;
            flex-direction: column;
            align-self: center;
        }

        div.s8-user div.s8-personal span {
                line-height: 1;
                display: block;
            }

        div.s8-user div.s8-personal span.s8-name {
                    margin-bottom: 2px;
                }

        div.s8-user div.s8-personal span.s8-tagline,
                div.s8-user div.s8-personal span.s8-position {
                    font-size: 10px;
                    color: rgb(150, 150, 145);
                    margin-bottom: 2px;
                }

        div.s8-user div.s8-personal :global(span) {
                line-height: 1;
            }

        div.s8-user div.s8-contact {
            display: flex;
        }

        div.s8-user div.s8-contact :global(span.s8-label) {
                display: none;
            }</style>